import React from 'react';
import {
  Icon, IconButton, makeStyles, Typography, Box,
} from '@material-ui/core';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import SchedulerDay from './SchedulerDay';
import { availabilitiesPeriod } from '../../config/config';
import { selectedClinicAvailabilitiesFilteredState, selectedDayjsState } from '../../state/selected';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 100,
  },
  weekHeader: {
    display: 'flex',
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  prev: {
    flex: '0 0',
  },
  week: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 0',
  },
  next: {
    flex: '0 0',
  },
  days: {
    display: 'flex',
    padding: `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)}`,
  },
  day: {
    flex: '1 0',
    padding: `0 ${theme.spacing(1)}`,
  },
  iconButton: {
    border: '1px solid',
  },
}));

const Scheduler = () => {
  const classes = useStyles();
  const today = dayjs();

  const [
    selectedDayjs, setSelectedDayjs,
  ] = useRecoilState(selectedDayjsState);
  const selectedClinicAvailabilitiesFiltered = useRecoilValue(
    selectedClinicAvailabilitiesFilteredState,
  );

  const isWeekEmpty = selectedClinicAvailabilitiesFiltered.filter((av) => {
    const avDate = dayjs(av.date);

    return avDate.isSameOrAfter(selectedDayjs.day(1), 'day')
      && avDate.isSameOrBefore(selectedDayjs.day(7), 'day');
  }).length < 1;

  const prevWeek = () => {
    setSelectedDayjs(selectedDayjs.subtract(7, 'day'));
  };

  const nextWeek = () => {
    setSelectedDayjs(selectedDayjs.add(7, 'day'));
  };

  const renderHeaderMonth = (date) => {
    const monday = date.day(1);
    const sunday = date.day(7);
    const mondayMonth = monday.format('MMMM');
    const sundayMonth = sunday.format('MMMM');
    const mondayYear = monday.format('YYYY');
    const sundayYear = sunday.format('YYYY');

    if (mondayMonth === sundayMonth) {
      return `${mondayMonth} ${mondayYear}`;
    }

    if (mondayYear !== sundayYear) {
      return `${mondayMonth} ${mondayYear} / ${sundayMonth} ${sundayYear}`;
    }

    return `${mondayMonth} / ${sundayMonth} ${sundayYear}`;
  };

  return (
    <div className={classes.container}>
      <div className={classes.weekHeader}>
        <div className={classes.prev}>
          <IconButton
            className={classes.iconButton}
            size="small"
            color="primary"
            onClick={prevWeek}
            disabled={today.isAfter(selectedDayjs.day(0), 'day')}
          >
            <Icon>navigate_before</Icon>
          </IconButton>
        </div>
        <div className={classes.week}>
          <Typography variant="h6" component="div" align="center">
            {renderHeaderMonth(selectedDayjs)}
          </Typography>
        </div>
        <div className={classes.next}>
          <IconButton
            className={classes.iconButton}
            size="small"
            color="primary"
            onClick={nextWeek}
            disabled={today.add(availabilitiesPeriod.nb, availabilitiesPeriod.unit)
              .isBefore(selectedDayjs.day(6), 'day')}
          >
            <Icon>navigate_next</Icon>
          </IconButton>
        </div>
      </div>
      <div className={classes.days}>
        {Array(7)
          .fill(0)
          .map((day, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className={classes.day} key={(i)}>
              <SchedulerDay day={selectedDayjs.day(i + 1)} />
            </div>
          ))}
      </div>
      {isWeekEmpty
        && (
          <Box mt={2} mb={2}>
            <Typography component="div" align="center">
              <FormattedMessage id="Scheduler.msgWeekIsEmpty" />
            </Typography>
          </Box>
        )}
    </div>
  );
};

Scheduler.propTypes = {};

export default Scheduler;
